import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Autocomplete from '@mui/material/Autocomplete';

import MaterialDivider from './MaterialDivider';

const FinalLNPSamplesForm = ({ index, data }) => {
  const { 
    handleDelete, handleInputChange, initialValues, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Final LNP Sample'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="LNP Sample Replicate"
            name={`final_lnp_sample_name-${data?.index}`}
            value={data?.final_lnp_sample_name}
            onChange={e => 
              handleInputChange(e, data?.index, 'final_lnp_sample_name', e.target.value)
            }
            helperText={formErrors[`final_lnp_sample_name-${data?.index}`]}
            error={`final_lnp_sample_name-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Final payload concentration after purification"
            name={`final_payload_concentration_after_purification-${data?.index}`}
            value={data?.final_payload_concentration_after_purification}
            onChange={e => 
              handleInputChange(
                e, data?.index, 'final_payload_concentration_after_purification', e.target.value
              )
            }
            helperText={
              formErrors[`final_payload_concentration_after_purification-${data?.index}`]
            }
            error={
              `final_payload_concentration_after_purification-${data?.index}` in formErrors
            }
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Volume after purification"
            name={`volume_after_purification-${data?.index}`}
            value={data?.volume_after_purification}
            onChange={e => 
              handleInputChange(e, data?.index, 'volume_after_purification', e.target.value)
            }
            helperText={formErrors[`volume_after_purification-${data?.index}`]}
            error={`volume_after_purification-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            value={data?.buffer_acronym}
            onChange={(e, newValue) => 
              handleInputChange(e, data?.index, 'buffer_acronym', newValue)
            }
            options={initialValues?.buffer_acronym_list}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Buffer Name" 
                placeholder="Type to search Buffer Name..." 
                error={`buffer_name-${data?.index}` in formErrors}
                helperText={formErrors[`buffer_name-${data?.index}`]}
              />
            )}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Buffer Unique ID"
            name={`buffer_unique_id-${data?.index}`}
            value={data?.buffer_unique_id}
            onChange={e => 
              handleInputChange(e, data?.index, 'buffer_unique_id', e.target.value)
            }
            helperText={formErrors[`buffer_unique_id-${data?.index}`]}
            error={`buffer_unique_id-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
};

FinalLNPSamplesForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default FinalLNPSamplesForm;